import { s } from "@kosmod/pancake";
import { defineTool } from "./define";
import { DiceExpression, DiceTemplateID, Die } from "@kosmod/andy";

export const dice = {
  roll: defineTool({
    key: 'dice:roll',
    state: s.o({
      diceTemplateId: DiceTemplateID
    })
  }),
  cleanup: defineTool({
    key: 'dice:cleanup',
    state: s.o({
      radius: s.num
    })
  }),
}